var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apple-login-container",attrs:{"id":"appleid-signin","data-type":"sign in"},on:{"click":_vm.handleClickSign}})
}
var staticRenderFns = []

export { render, staticRenderFns }